module.exports = __webpack_public_path__ + "static/media/chu-detail-title-icon.24be12ec.png";